export default {
	title: 'Son alimentation',
	textliensutiles: 'Liens utiles :',
	trancheage: {
		mois1: {
			text: 'Pendant les 4 premiers mois de vie de votre bébé, le lait sera l\'aliment exclusif. Il lui fournit l\'ensemble des nutriments dont il a besoin. Vous pouvez choisir de l\'allaiter ou de le nourrir au biberon, dans ce cas utilisez un lait « 1<sup>er</sup> âge ». En cas de fièvre ou de forte chaleur vous pouvez compléter avec de l\'eau minérale.',
			aliment: [
				'laitmaternel','lait1age','eaufievre'
			],
			lienutile: [
				'allaitementmaternel','alimentation0a3ans'
			]
		},
		mois2: {
			text: 'Pendant les 4 premiers mois de vie de votre bébé, le lait sera l\'aliment exclusif. Il lui fournit l\'ensemble des nutriments dont il a besoin. Vous pouvez choisir de l\'allaiter ou de le nourrir au biberon, dans ce cas utilisez un lait « 1<sup>er</sup> âge ». En cas de fièvre ou de forte chaleur vous pouvez compléter avec de l\'eau minérale.',
			aliment: [
				'laitmaternel','lait1age','eaufievre'
			],
			lienutile: [
				'allaitementmaternel','alimentation0a3ans'
			]
		},
		mois3: {
			text: 'Pendant les 4 premiers mois de vie de votre bébé, le lait sera l\'aliment exclusif. Il lui fournit l\'ensemble des nutriments dont il a besoin. Vous pouvez choisir de l\'allaiter ou de le nourrir au biberon, dans ce cas utilisez un lait « 1<sup>er</sup> âge ». En cas de fièvre ou de forte chaleur vous pouvez compléter avec de l\'eau minérale.',
			aliment: [
				'laitmaternel','lait1age','eaufievre'
			],
			lienutile: [
				'allaitementmaternel','alimentation0a3ans'
			]
		},
		mois4: {
			text: 'Pendant les 4 premiers mois de vie de votre bébé, le lait sera l\'aliment exclusif. Si vous avez choisi d\'allaiter, vous pouvez continuer aussi longtemps que vous le souhaitez.',
			aliment: [
				'laitmaternel','lait1age','eaufievre'
			],
			lienutile: [
				'allaitementmaternel','alimentation0a3ans'
			]
		},
		mois6: {
			text: 'Le lait maternel ou un « lait 2<sup>ème</sup> âge » constitue la base de l\'alimentation de votre bébé, mais vous pouvez commencer à diversifier son alimentation en introduisant quelques aliments, comme ceux présentés ci-dessous. En cas de fièvre ou forte chaleur continuez à lui donner de l\'eau minérale pure.',
			aliment: [
				'lait2age','pureepommedeterre','pureelegumes','cerealesansgluten','fruitsmurs','eaufievre'
			],
			lienutile: [
				'allaitementmaternel','alimentation0a3ans'
			]
		},
		mois8: {
			text: '<p>Le lait maternel ou un « lait 2<sup>ème</sup> âge » reste la base de l\'alimentation de votre bébé mais vous pouvez continuer à diversifier son alimentation avec les aliments présentés ci-dessous.</p><p class="mb-2">Si vous aviez choisi d\'allaiter votre bébé, vous pouvez commencer à le « sevrer », c\'est-à-dire commencer à arrêter l\'allaitement au sein. Cette étape peut être délicate, prenez votre temps pour que tout se passe bien.</p>',
			aliment: [
				'yaourt','viandepoissonhachee10g','semoule','riz','pain','lait2age','pureepommedeterre','pureelegumes','cerealesansgluten','fruitsmurs','eaufievre'
			],
			lienutile: [
				'alimentation0a3ans'
			]
		},
		mois11: {
			text: '<p>En plus du lait maternel ou un « lait 2<sup>ème</sup> âge » (500 ml/j) vous pouvez proposer à votre bébé une nouvelle gamme de saveur.</p><p class="ma-0 font-weight-bold">Vous pouvez lui donner les aliments suivants :</p>',
			aliment: [
				'viandepoissonhacheoeuf20g','patesfines','yaourt','semoule','riz','pain','lait2age','pureepommedeterre','pureelegumes','cerealesansgluten','fruitsmurs','eaufievre'
			],
			lienutile: [
				'alimentation0a3ans'
			]
		},
		mois12: {
			text: '<p>En plus du lait maternel ou un « lait 2<sup>ème</sup> âge » (500 ml/j) vous pouvez proposer à votre bébé une nouvelle gamme de saveur.</p><p class="ma-0 font-weight-bold">Vous pouvez lui donner les aliments suivants :</p>',
			aliment: [
				'viandepoissonhacheoeuf20g','patesfines','yaourt','semoule','riz','pain','lait2age','pureepommedeterre','pureelegumes','cerealesansgluten','fruitsmurs','eaufievre'
			],
			lienutile: [
				'alimentation0a3ans'
			]
		},
		mois15: {
			text: 'Votre enfant a maintenant une alimentation variée, qui va se rapprocher petit à petit de la vôtre, mais dans des quantités adaptées à son âge. Il a encore des besoins spécifiques et des capacités physiologiques limitées.',
			aliment: [
				'viandepoissonhacheoeuf20g','patesfines','yaourt','semoule','riz','pain','lait2age','pureepommedeterre','pureelegumes','cerealesansgluten','fruitsmurs','eaufievre'
			],
			lienutile: [
				'alimentation0a3ans'
			]
		},
		mois18: {
			text: 'Votre enfant a maintenant une alimentation variée, qui va se rapprocher petit à petit de la vôtre, mais dans des quantités adaptées à son âge. Il a encore des besoins spécifiques et des capacités physiologiques limitées.',
			aliment: [
				'viandepoissonhacheoeuf20g','patesfines','yaourt','semoule','riz','pain','lait2age','pureepommedeterre','pureelegumes','cerealesansgluten','fruitsmurs','eaufievre'
			],
			lienutile: [
				'alimentation0a3ans'
			]
		},
		mois23: {
			text: 'Votre enfant a maintenant une alimentation variée, qui va se rapprocher petit à petit de la vôtre, mais dans des quantités adaptées à son âge. Il a encore des besoins spécifiques et des capacités physiologiques limitées.',
			aliment: [
				'viandepoissonhacheoeuf20g','patesfines','yaourt','semoule','riz','pain','lait2age','pureepommedeterre','pureelegumes','cerealesansgluten','fruitsmurs','eaufievre'
			],
			lienutile: [
				'alimentation0a3ans'
			]
		},
		mois24: {
			text: 'Vous pouvez augmenter un peu les quantités de nourriture et proposer à votre enfant des aliments mous en morceaux.',
			aliment: [
				'legumesecrases','fruitsmorceaux','viandepoissonhacheoeuf30g','patesfines','yaourt','semoule','riz','pain','lait2age','pureepommedeterre','eaufievre'
			],
			lienutile: [
				'alimentation0a3ans'
			]
		},
		mois36: {
			text: '<p>L\'eau est la seule boisson recommandée au cours et en dehors des repas. Evitez de donner l\'habitude du sirop dans le verre d\'eau. Limitez la consommation de produits gras, sucrés et de sel. Demandez toujours à votre enfant de goûter avant de resaler son assiette.</p><p class="ma-0 font-weight-bold">Les repères alimentaires pour les enfants sont les suivants :</p>',
			textsuite:'<p class="mb-2">Entre 3 et 6 ans votre enfant s\'oppose, c\'est normal. Il dit non pour mettre ses chaussures, non pour aller sous la douche et non, bien sûr, pour manger ce que vous lui proposez. C\'est sa façon de vous indiquer qu\'il a grandi. N\'ayez pas peur de lui dire « non » à votre tour. Votre enfant a besoin de limites fermes pour se construire. C\'est vous qui savez ce qui est bien pour lui ou pas. C\'est vous qui décidez du menu.</p><p class="mb-2">Par ailleurs l\'activité physique est aussi importante que l\'alimentation. Toute occasion de bouger est bonne.</p>',
			aliment: [
				'fruitsetlegumes','produitslaitiers','feculents','viandepoisson50goeuf','eau'
			],
			lienutile: [
				'alimentation0a3ans'
			]
		},
		mois48: {
			text: '<p>La vie familiale et scolaire entraîne une organisation en 3 repas par jour, auxquels s\'ajoute le goûter. La collation le matin n\'est pas forcément nécessaire. Elle augmente inutilement l\'apport calorique de la journée et peut couper l\'appétit de certains enfants pour le déjeuner.</p><p>L\'équilibre alimentaire ne se fait pas sur un seul repas mais sur la journée, et même sur plusieurs jours.</p><p>L\'eau est la seule boisson recommandée au cours et en dehors des repas. Evitez de donner l\'habitude du sirop dans le verre d\'eau. Limitez la consommation de produits gras, sucrés et de sel. Demandez toujours à votre enfant de goûter avant de resaler son assiette.</p><p class="ma-0 font-weight-bold">Les repères alimentaires pour les enfants sont les suivants :</p>',
			textsuite: 'Si une alimentation équilibrée est nécessaire, une activité physique régulière est aussi importante. Elle favorise une bonne croissance, fait progresser les capacités d\'apprentissage, procure du plaisir (par la sécrétion d\'endorphines) et permet de nouer de nouvelles relations sociales.',
			aliment: [
				'fruitsetlegumes','produitslaitiers','feculents','viandepoisson50goeuf','eau'
			],
			lienutile: [
				'alimentation3a18ans'
			]
		},
		mois60: {
			text: '<p>L\'eau est la seule boisson recommandée au cours et en dehors des repas. Evitez de donner l\'habitude du sirop dans le verre d\'eau. Limitez la consommation de produits gras, sucrés et de sel. Demandez toujours à votre enfant de goûter avant de resaler son assiette.</p><p class="ma-0 font-weight-bold">Les repères alimentaires pour les enfants sont les suivants :</p>',
			textsuite: '<p class="mb-2">L\'équilibre alimentaire ne se fait pas sur un seul repas mais sur la journée, et même sur plusieurs jours.</p><p class="mb-2">Par ailleurs, la pratique d\'une activité physique régulière est recommandée tous les jours : toute occasion de bouger est bonne.</p>',
			aliment: [
				'viandepoissonhacheoeuf1e2fois','feculents','fruitsetlegumes','produitslaitiers','eau'
			],
			lienutile: [
				'alimentation3a18ans'
			]
		},
		mois84: {
			text: '<p>L\'eau est la seule boisson recommandée au cours et en dehors des repas. Evitez de donner l\'habitude du sirop dans le verre d\'eau. Limitez la consommation de produits gras, sucrés et de sel. Demandez toujours à votre enfant de goûter avant de resaler son assiette.</p><p class="ma-0 font-weight-bold">Les repères alimentaires pour les enfants sont les suivants :</p>',
			textsuite: '<p class="mb-2">L\'équilibre alimentaire ne se fait pas sur un seul repas mais sur la journée, et même sur plusieurs jours.</p><p class="mb-2">Par ailleurs, la pratique d\'une activité physique régulière est recommandée tous les jours : toute occasion de bouger est bonne.</p>',
			aliment: [
				'viandepoissonhacheoeuf1e2fois','feculents','fruitsetlegumes','produitslaitiers','eau'
			],
			lienutile: [
				'alimentation3a18ans'
			]
		},
		mois108: {
			text: '<p>Votre enfant peut commencer à prendre un goûter. Il ne doit pas se transformer en plusieurs goûters pour les petits gourmands et ne doit pas être pris trop proche du dîner. Si votre enfant rentre de l\'école vers 18h et qu\'il vous dit qu\'il a faim, essayez plutôt d\'avancer l\'heure du repas plutôt que de lui redonner un goûter.</p><p class="ma-0 font-weight-bold">Limitez la consommation de produits gras, sucrés et de sel. Les repères alimentaires pour les enfants sont les suivants :</p>',
			textsuite: '<p class="mb-2">L\'équilibre alimentaire ne se fait pas sur un seul repas mais sur la journée, et même sur plusieurs jours.</p><p class="mb-2">Par ailleurs, la pratique d\'une activité physique régulière est recommandée tous les jours : toute occasion de bouger est bonne.</p><p class="mb-2">Encouragez votre enfant, et si possible pratiquez avec lui, des jeux de plein air (jeux de ballon, vélo, roller, trottinette, corde à sauter, élastique, parcours de santé, foot, etc.) Il est préférable de ne pas laisser la télévision allumée durant les repas. De plus il est recommandé de ne pas mettre de télévision ou d\'ordinateur dans la chambre de votre enfant.</p>',
			aliment: [
				'viandepoissonhacheoeuf1e2fois','feculents','fruitsetlegumes','produitslaitiers','eau'
			],
			lienutile: [
				'activitephysique','alimentation3a18ans'
			]
		},
		mois156: {
			text: '<p>A l\'adolescence, il est important de ne pas délaisser le petit déjeuner. S\'il est insuffisant, votre adolescent risque de grignoter dans la matinée. De plus, il manquera peut-être de concentration en classe. Les apports en calcium sont importants et doivent être présents dès le petit déjeuner.</p><p class="ma-0 font-weight-bold">Limitez la consommation de produits gras, sucrés et de sel. Les repères alimentaires sont les suivants :</p>',
			textsuite: '<p class="mb-2">L\'équilibre alimentaire ne se fait pas sur un seul repas mais sur la journée, et même sur plusieurs jours.</p><p class="mb-2">Par ailleurs, la pratique d\'une activité physique régulière est recommandée tous les jours : toute occasion de bouger est bonne.</p><p class="mb-2">Encouragez votre enfant, et si possible pratiquez avec lui, des jeux de plein air (jeux de ballon, vélo, roller, trottinette, corde à sauter, élastique, parcours de santé, foot, etc.) Il est préférable de ne pas laisser la télévision allumée durant les repas. De plus il est recommandé de ne pas mettre de télévision ou d\'ordinateur dans la chambre de votre enfant.</p>',
			aliment: [
				'oeuf100g','feculents','fruitsetlegumes','produitslaitiers','eau'
			],
			lienutile: [
				'activitephysique','alimentation3a18ans'
			]
		}
	}
};
